// extracted by mini-css-extract-plugin
export default {"ActionButton":"ShortUrlForm_ActionButton__R5hK3","SlugLabel":"ShortUrlForm_SlugLabel__yzzyL"};